import { removeUserService } from "../infrastructure/services/removeUserService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const removeUser = {
  async execute(username: string): Promise<void> {
    await removeUserService.execute(await tokenValidation.execute(), username);
  },
};
